<template>
<div class="hk-nav supreme-container" :class="[this.MobileView, this.GetCountry, this.currentRouteName]">
    <nav class="navbar navbar-expand-lg navbar-dark hk-navbar" :class="this.IsDarkMode + ' ' + this.MobileView">
        <div class="container">
            <router-link :to="'/'" class="navbar-brand">

                <!-- desktop menu -->
                 <div class="d-none d-lg-block">
                    <img :src="getLogo" width="146" alt="logo" />
                </div>

                <!-- Mobile menu -->
               <div class="d-lg-none">
                    <img :src="getMobileLogo" width="146" alt="logo" />
                </div>

            </router-link>

            <!-- mobile menu -->
           <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main_nav" aria-expanded="false" aria-label="Toggle navigation">
        <div class="mob-menu-btn">
            <img 
                v-if="!MobileMenu" 
                src="@/assets/logo/bar_img.svg" 
                alt="menu icon" 
                class="bar_menu-icon hk-mouse-pointer hkwin" 
                width="35" 
                @click="toggleMobileMenu" 
            />
            <img 
                v-if="MobileMenu" 
                src="@/assets/logo/close.svg" 
                alt="menu icon" 
                class="bar_menu-icon hk-mouse-pointer hkwin" 
                width="35" 
                @click="toggleMobileMenu" 
            />
        </div>
    </button>

            <!-- desktop menu -->
            <div class="collapse d-none d-md-none d-lg-flex hk-desktop-menu" id="main_nav">
                <ul class="navbar-nav "></ul>
                <ul class="navbar-nav nav-bar-align">
                    <!-- Reginon Button -->
                    <li class="nav-item">
                        <router-link class="nav-link" :to="'/region'">Regions</router-link>
                    </li>
                    <!-- Industries Button -->
                    <li class="nav-item">
                        <router-link class="nav-link" :to="'/industries'">{{ $t("menubar.industries") }}</router-link>
                    </li>
                    <!-- Overviews Button -->
                    <li class="nav-item">
                        <router-link class="nav-link" :to="'/overviews'">{{ $t("menubar.overview") }}</router-link>
                    </li>
                    <!-- Product/ Solutions -->
                    <!-- Add product and subproduct in js file below -->
                    <li class="nav-item dropdown has-megamenu">
                     <div class="nav-link nav-links" @click="toggleMenu('products')">{{ $t("menubar.solutions.solutions") }}
                        <img src="@/assets/home/arrow-down-16.svg" alt="Caret Down" class="caret-icon" />
                    </div>

                        <div class="megamenu container mx-auto border-0" role="menu" v-if="showProducts" @mouseleave="handleMouseLeave('products')">
                            <div class="row g-3 border-0 p-4 bg-megamenu">
                                <!-- Left side with main products -->
                                <div class="col-lg-5 col-5 mt-0">
                                    <div class="col-megamenu mega-left" style="max-height: 600px">
                                        <div class="row">
                                            <div class="col-12 mega-product-heading p-0">
                                                <h2>Core Solutions </h2>
                                            </div>
                                            <div v-for="(product, index) in mainProducts" :key="index" class="col-12 p-0">
                                                <a :href="product.link" target="_blank" class="nav-link hk-row-menus p-0" :to="product.link" @mouseover="showSubProducts(index)">
                                                    <h3 class="m-0 ps-2">{{ product.name }}</h3>
                                                </a>
                                                <!-- Insert an <hr> after every 7th item, below the <h3> -->
                                                <hr class="sec-hr" v-if="(index + 1) % 7 === 0" />
                                                <div class="col-12 mega-product-heading p-0">
                                                    <h2 v-if="(index + 1) % 7 === 0" class="">Value-Added Solutions </h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Right side with sub-products -->
                                <div class="col-lg-7 col-7 mt-0">
                                    <div class="col-megamenu mega-right" style="max-height: 600px;  auto">
                                        <div class="row">
                                            <div class="col-12 mega-product-heading p-0">
                                                <h2>{{ $t("menubar.overview") }}</h2>
                                            </div>
                                            <div v-if="activeMainProductIndex !== null" @click="handleClick" class="clickable-container m-0 p-0">
                                                <div v-if="mainProducts[activeMainProductIndex].overview" class="overview" @click="
                              openLink(
                                mainProducts[activeMainProductIndex].link
                              )
                            ">
                                                    <!-- <img :src="mainProducts[activeMainProductIndex].overview.image" :alt="mainProducts[activeMainProductIndex].overview.name" /> -->
                                                    <div class="pe-4 m-0">
                                                        <h6 class="hover-text">
                                                            {{
                                  mainProducts[activeMainProductIndex].overview
                                    .name
                                }}
                                                        </h6>
                                                        <p class="hk-subbody">
                                                            {{
                                  mainProducts[activeMainProductIndex].overview
                                    .description
                                }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="
                            mainProducts[activeMainProductIndex] &&
                            mainProducts[activeMainProductIndex].subProducts &&
                            mainProducts[activeMainProductIndex].subProducts
                              .length > 0
                          ">
                                                <hr />
                                                <div class="col-12 mega-product-heading p-0">
                                                    <h2>{{ $t("menubar.solutions.features") }}</h2>
                                                </div>
                                                <div v-for="subProduct in mainProducts[
                              activeMainProductIndex
                            ].subProducts" :key="subProduct.name" class="col-12 p-0">
                                                    <router-link class="nav-link hk-row-menus p-0" :to="subProduct.link" @mouseover="showSubProductDetails(subProduct)">
                                                        <div>
                                                            <h3>{{ subProduct.name }}</h3>
                                                        </div>
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- Technology Button -->

                    <!-- About us Button -->
                    <!-- <li class="nav-item">
                        <a class="nav-link" :to="'/company'">About Us</a>
                    </li> -->
                    <!-- Technology dropdown Button-->
                    <li class="nav-item dropdown has-megamenu">
                        <div class="nav-link nav-links" @click="toggleMenu('aboutus')">
                            
                            Company
                              <img src="@/assets/home/arrow-down-16.svg" alt="Caret Down" class="caret-icon" />
                              

                          
                        </div>
                        <div class="megamenu-aboutus container mx-auto border-0" role="menu" v-if="showAboutus" @mouseleave="handleMouseLeave('aboutus')">
                            <div class="row p-2 border-0 bg-megamenu">
                                <div class="col-lg-12 col-12 mt-0">
                                    <div class="col-megamenu mega-left">
                                        <div class="row">
                                            <div class="col-12 mega-product-heading">
                                                <!-- <h2>{{ $t("menubar.about_us") }}</h2> -->
                                            </div>
                                            <div v-for="(techonology, index) in mainTechonology" :key="index" class="col-12">
                                                <a :href="techonology.link" class="nav-link hk-row-menus" @mouseover="showSubProducts(index)">
                                                    <!-- <img :src="techonology.image" alt="Main Product Image" /> -->

                                                    <h3 class="">{{ techonology.name }}</h3>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                    <!-- language destop-menu -->
                    <!-- <li class="nav-item">
                        <language></language>
                    </li> -->

                    <!-- Contact us -->
                    <ul class="navbar-nav ml-auto d-flex align-items-right">
                        <li class="nav-item">
                            <router-link :to="'/contact-team'" class="nav-link p-0">
                                <button type="button" class="btn btn-request-demo" :to="'contact-team'">
                                    {{ $t("hk_all_btn.demo_btn") }}
                                    <!-- <i class="fa-solid fa-circle-chevron-right"></i> -->
                                    <img src="@/assets/common/arrow-circle-right.svg" alt="arrow-circle-right-svg" class="w-auto demo-svg" />
                                </button>
                            </router-link>
                        </li>

                 
                    
                    </ul>
                </ul>
            </div>

            <!-- ------------------mobile menu------------ -->

            <div class="collapse navbar-collapse d-flex d-md-flex d-lg-none hk-mobile-menu pt-2" id="main_nav" v-if="MobileMenu">
                <ul class="navbar-nav mob-nav-overflow">
                    <!-- language mobile-menu -->
                    <!-- <li class="nav-item">
                        <language></language>
                    </li> -->
                    <!-- <li class="nav-item">
                        <router-link class="nav-link" :to="'/company'">{{
                $t("nav_bar.about_us")
              }}</router-link>
                    </li> -->
                    <li class="nav-item">
                        <div class="dropdown">
                            <!-- <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                {{ $t("nav_bar.products") }}
                            </a> -->

                            <a class="dropdown-toggle d-flex align-items-center justify-content-between" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
    {{ $t("nav_bar.products") }}
    <img src="@/assets/home/arrow-down-16.svg" alt="Dropdown Icon" class="ms-2" width="16" height="16">
</a>

                            <ul class="dropdown-menu border-0" aria-labelledby="dropdownMenuLink">
                                <!-- <a class="nav-link hk-row-menus dropdown-item" :to="'/property-management-system'">{{ $t('product_menus.pms') }}</a>
                                <a class="nav-link hk-row-menus dropdown-item" :to="'/rate-management-system'">{{ $t('product_menus.rms') }}</a>
                                <a class="nav-link hk-row-menus dropdown-item" :to="'/retail-key'">{{ $t('product_menus.retail_key') }}</a>
                                <a class="nav-link hk-row-menus dropdown-item" :to="'/event-key'"> {{ $t('product_menus.event_key') }}</a>
                                <a class="nav-link hk-row-menus dropdown-item" :to="'/central-reservation-system'">{{ $t('product_menus.crs') }}</a>
                                <a class="nav-link hk-row-menus dropdown-item" :to="'/business-intelligence'">{{ $t('product_menus.bi') }}</a>
                                <a class="nav-link hk-row-menus dropdown-item" :to="'/payment-key'">{{ $t('product_menus.payment_key') }}</a>
                                <a class="nav-link hk-row-menus dropdown-item" :to="'/integrations'">{{ $t('product_menus.integrations') }}</a>
                                <a class="nav-link hk-row-menus" :to="'/iotkey'">
                                    <h3>{{ $t('product_menus.iot_key') }}</h3>
                                </a>
                                <a class="nav-link hk-row-menus" :to="'/tenant-key'"><h3>{{$t('product_menus.tetant_key')}}</h3></a> -->

                                <!-- product dynamic  -->
                                <div class="mega-product-heading">
                                    <h2 class="pb-2">Core Solutions</h2>

                                    <div v-for="(product, index) in mainProducts" :key="product.name" class="product-container">

                                        <a :href="product.link" class="product-link" :class="{ active: isActive(product.link) }">

                                            <div class="product-info">
                                                <h3 class="product-name mob-product-name ps-3">
                                                    {{ product.name }}

                                                </h3>

                                            </div>

                                        </a>
                                        <hr v-if="(index + 1) % 7 === 0" class="" />
                                        <div class="col-12 mega-product-heading p-0">
                                            <h2 v-if="(index + 1) % 7 === 0" class="p-0">Value-Added Solutions </h2>
                                        </div>
                                    </div>

                                </div>
                            </ul>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="dropdown">
                            <a class="dropdown-toggle d-flex align-items-center justify-content-between " href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                               Company
                                    <img src="@/assets/home/arrow-down-16.svg" alt="Dropdown Icon" class="ms-2" width="16" height="16">

                            </a>

                            <ul class="dropdown-menu border-0 pt-3" aria-labelledby="dropdownMenuLink">
                                <div>
                                    <div v-for="techonology in mainTechonology" :key="techonology.name" class="product-container">
                                        <a :href="techonology.link" class="product-link">
                                            <div class="product-info">
                                                <!-- <img :src="techonology.image" :alt="product.name" class="product-img" /> -->
                                                <h3 class="product-name mob-product-name">
                                                    {{ techonology.name }}
                                                </h3>

                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </ul>
                        </div>
                    </li>

                    <!-- <li class="nav-item">
                        <router-link class="nav-link" :to="'/services'">{{
                $t("nav_bar.services")
              }}</router-link>
                    </li> -->

                    <!-- Reginon mob btn  -->

                    <li class="nav-item">
                        <router-link class="nav-link" :to="'/region'">{{
                $t("menubar.region")
              }}</router-link>
                    </li>
                    <!-- Industries mob btn  -->
                    <li class="nav-item">
                        <router-link class="nav-link" :to="'/industries'">{{
                $t("menubar.industries")
              }}</router-link>
                    </li>
                    <!-- Overview mob btn -->
                    <li class="nav-item">
                        <router-link class="nav-link" :to="'/overviews'">{{
                $t("menubar.overview")
              }}</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

    <!-- side menu -->
    <div v-if="this.SideMenuBar" class="side-menu-grid" :class="{ sidenavopen: SideMenuBar }">
        <div class="hk-menus">
            <div class="header-close-button">
                <button class="btn btn-sm" @click="this.OpenSideMenu()">
                    <span>X</span>
                </button>
            </div>
            <div class="sidemenu-height">
                <ul class="list-group list-group-flush text-center">
                    <!-- <li class="list-group-item border-bottom-0">
            <a class="nav-link" :to="'/company'">About Us</a>
          </li> -->
                    <!-- <li class="list-group-item border-bottom-0">
              <a class="nav-link" :to="'/services'">{{ $t('nav_bar.services') }}</a>
            </li>
            <li class="list-group-item border-bottom-0">
              <a class="nav-link" :to="'/contact-team'">{{ $t('nav_bar.contact_us') }}</a>
            </li>
            <li class="list-group-item border-bottom-0">
              <a class="nav-link" :to="'/support'">{{ $t('nav_bar.support') }}</a>
            </li>
            <li class="list-group-item border-bottom-0">
              <a class="nav-link" :to="'/news-blogs/news'">{{ $t('nav_bar.news_blogs') }}</a>
            </li>
            <li class="list-group-item border-bottom-0">
              <a class="nav-link" :to="'/careers'">{{ $t('nav_bar.join_our_team') }}</a>
            </li> -->
                </ul>
                <div class="d-block mx-auto text-center">
                    <ul class="list-inline mb-0 hk-list-inline-item">
                        <li class="list-inline-item fs-14 text-uppercase">
                            {{ $t("footer.contact_with_us") }} <span> - </span>
                        </li>
                        <li class="list-inline-item hk-list-inline-item">
                            <a href="https://www.facebook.com/hotelkeyapp/" class="hk-a" target="_blank">
                                <font-awesome-icon icon="fa-brands fa-square-facebook" class="" />
                            </a>
                        </li>
                        <li class="list-inline-item hk-list-inline-item">
                            <a href="https://twitter.com/HotelKeyInc" class="hk-a" target="_blank">
                                <font-awesome-icon icon="fa-brands fa-square-twitter" class="" />
                            </a>
                        </li>
                        <li class="list-inline-item hk-list-inline-item">
                            <a href="https://www.instagram.com/hotelkeyinc/" class="hk-a" target="_blank">
                                <font-awesome-icon icon="fa-brands fa-square-instagram" class="" />
                            </a>
                        </li>
                        <li class="list-inline-item hk-list-inline-item">
                            <a href="https://www.linkedin.com/company/hotelkey/?viewAsMember=true" class="hk-a" target="_blank">
                                <font-awesome-icon icon="fa-brands fa-linkedin" class="" />
                            </a>
                        </li>
                        <li class="list-inline-item hk-list-inline-item">
                            <a href=" https://wa.me/19724397067" aria-label="whatsapp" class="hk-a" target="_blank">
                                <font-awesome-icon icon="fa-brands fa-square-whatsapp" class="" />
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Language from "./Language.vue";
import axios from "axios";


export default {
    components: {
        Language,
    },
    name: "MenuBar",
    data() {
        return {
            showProducts: false,
            showAboutus: false,
            showIndustries: false,
            showRegions: false, // Add this line for Regions
            activeMainProductIndex: null,
            activeSubProduct: null,
            SideMenuBar: false,
            MobileMenu: false,
            GetCountry: "",
            CheckLocation: null,
            WhiteLogo: null,
            activeMainProductIndex: null,
            activeSubProduct: null,

            mainTechonology: [{
                    name: this.$t("menubar.about_us_dropdown.support"),
                    link: "/support", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
                {
                    name: this.$t("menubar.about_us"),
                    link: "/company", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
                {
                    name: this.$t("menubar.about_us_dropdown.our_office"),
                    link: "/our-office", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
                {
                    name: this.$t("menubar.about_us_dropdown.work_with_us"),
                    link: "/careers", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
                {
                    name: "News/Blogs",
                    link: "/news-blogs", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
                {
                    name: this.$t("menubar.about_us_dropdown.contact_us"),
                    link: "/contact-team", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
                {
                    name: "Testimonials",
                    link: " /testimonials", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
            ],
            mainIndustries: [{
                    name: "Hotels & Resorts",
                    link: "/property-management-system", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
                {
                    name: "Restaurants & Food Services",
                    link: "/property-management-system", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
                {
                    name: "Leisure & Entertainment",
                    link: "/property-management-system", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
                {
                    name: "Conventions",
                    link: "/property-management-system", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
                {
                    name: "Events & Activities",
                    link: "/property-management-system", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
            ],
            mainRegions: [{
                    name: "AMERICAS",
                    link: "/property-management-system", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
                {
                    name: "AEAM",
                    link: "/property-management-system", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
                {
                    name: " APEC",
                    link: "/property-management-system", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                },
            ],
            mainProducts: [{
                    name: this.$t("menubar.solutions.hk_pms"),
                    link: "/property-management-system", // Add route link here
                    image: require("@/assets/home/menu-icon/pms.svg"),
                    overview: {
                        name: this.$t("menubar.solutions.hk_pms"),
                        image: require("@/assets/home/menu-icon/pms.svg"),
                        description: this.$t("product_menus.pms_sub_text"),
                    },
                    subProducts: [{
                            name: "Frontdesk",
                            link: "/front-desk",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate Management System",
                        },
                        {
                            name: "Housekeeping & Maintenance",
                            link: "/housekeeping-maintenance",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate Management System",
                        },
                        {
                            name: "Groups Management",
                            link: "/groups-management",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate Management System",
                        },
                        {
                            name: "Reports",
                            link: "/reports",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate Management System",
                        },
                        {
                            name: "Corporate Rates and Billing",
                            link: "/corporate-rates-billing",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate Management System",
                        },
                        {
                            name: "Property Settings",
                            link: "/property-administration",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate Management System",
                        },
                        {
                            name: "Lost & Found",
                            link: "/lost-found",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate Management System",
                        },
                        {
                            name: "GuestPad App",
                            link: "/guest-pad-app",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate Management System",
                        },
                        {
                            name: "Manager App",
                            link: "/manager-app",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate Management System",
                        },
                        {
                            name: "System Integrations",
                            link: "/system-integrations",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate Management System",
                        },
                        {
                            name: "",
                            link: "/",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate Management System",
                        },
                    ],
                },
                {
                    name: this.$t("menubar.solutions.hk-rk"),
                    link: "/retail-key",
                    image: require("@/assets/home/menu-icon/retailkey.svg"),
                    overview: {
                        name: this.$t("menubar.solutions.hk-rk"),
                        link: "/retail-key",
                        image: require("@/assets/home/menu-icon/retailkey.svg"),
                        description: this.$t("product_menus.retail_key_sub_text"),
                    },
                    subProducts: [{
                            name: "Register App",
                            link: "/register-app",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Register App",
                        },
                        // {
                        //     name: "Order Management",
                        //     link: "/order-management",
                        //     image: require("@/assets/home/menu-icon/rate_management.svg"),
                        //     description: "Description for Order Management",
                        // },
                        // {
                        //     name: "Order Taking App",
                        //     link: "/order-taking-app",
                        //     image: require("@/assets/home/menu-icon/rate_management.svg"),
                        //     description: "Description for Order Taking App",
                        // },
                        // {
                        //     name: "Kitchen Display System",
                        //     link: "/kitchen-display",
                        //     image: require("@/assets/home/menu-icon/rate_management.svg"),
                        //     description: "Description for Kitchen Display System",
                        // },
                        {
                            name: "Easy Payments",
                            link: "/easy-payments",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Easy Payments",
                        },
                        // {
                        //     name: "Hardware Integration",
                        //     link: "/hardware-integration",
                        //     image: require("@/assets/home/menu-icon/rate_management.svg"),
                        //     description: "Description for Hardware Integration",
                        // },
                        {
                            name: "Product Management",
                            link: "/product-management",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Product Management",
                        },
                        {
                            name: "Inventory Management",
                            link: "/inventory-management",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Inventory Management",
                        },
                        {
                            name: "Vendors & Purchase Management",
                            link: "/vendors-purchase-management",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Vendors & Purchase Management",
                        },
                        {
                            name: "Reporting & Analytics",
                            link: "/reporting-analytics",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Reporting & Analytics",
                        },
                    ],
                },

                {
                    name: this.$t("menubar.solutions.hk_ek"),
                    link: "/event-key",
                    image: require("@/assets/home/menu-icon/eventkey.svg"),
                    overview: {
                        name: this.$t("menubar.solutions.hk_ek"),
                        link: "/event-key",
                        image: require("@/assets/home/menu-icon/eventkey.svg"),
                        description: this.$t("product_menus.event_key_sub_text"),
                    },
                    subProducts: [{
                            name: "Event Administration & Setup",
                            link: "/event-administration-setup",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate & Room Type Admin",
                    }],
                },

                {
                    name: this.$t("menubar.solutions.hk_crs"),
                    link: "/central-reservation-system",
                    image: require("@/assets/home/menu-icon/crs.svg"),
                    overview: {
                        name: this.$t("menubar.solutions.hk_crs"),
                        link: "/central-reservation-system",
                        image: require("@/assets/home/menu-icon/crs.svg"),
                        description: "Seamless booking management with real-time integration of availability, rates, and reservations.",
                    },
                    subProducts: [{
                            name: "Rate & Room Type Admin",
                            link: "/rate-room-type-admin",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate & Room Type Admin",
                        },
                        {
                            name: "Rate Calendar",
                            link: "/rate-calendar",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate Calendar",
                        },
                        {
                            name: "Distribution",
                            link: "/distribution",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Distribution",
                        },
                        {
                            name: "Smart Booking Engine",
                            link: "/booking-engine",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Booking Engine",
                        },
                        {
                            name: "Property Website",
                            link: "/property-website",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Property Website",
                        },
                        {
                            name: "Find & Reserve",
                            link: "/find-reserve",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Rate Calendar",
                        },
                    ],
                },

                {
                    name: this.$t("menubar.solutions.hk_pk"),
                    link: "/payment-key",
                    image: require("@/assets/home/menu-icon/paymentkey.svg"),
                    overview: {
                        name: this.$t("menubar.solutions.hk_pk"),
                        link: "/payment-key",
                        image: require("@/assets/home/menu-icon/paymentkey.svg"),
                        description: this.$t("product_menus.payment_key_sub_text"),
                    },
                },
                {
                    name: this.$t("menubar.solutions.hk-tk"),
                    link: "/tenant-key",
                    image: require("@/assets/home/menu-icon/tenantkey.svg"),
                    overview: {
                        name: this.$t("menubar.solutions.hk-tk"),
                        link: "/tenant-key",
                        image: require("@/assets/home/menu-icon/tenantkey.svg"),
                        description: this.$t("product_menus.tetant_key_sub_text"),
                    },
                },
                // {
                //     name: this.$t("menubar.solutions.hk_ak"),
                //     link: "/activity-key",
                //     image: require("@/assets/home/menu-icon/integrations.svg"),
                //     overview: {
                //         name: this.$t("menubar.solutions.hk_ak"),
                //         link: "/activity-key",
                //         image: require("@/assets/home/menu-icon/integrations.svg"),
                //         description: "Simplify activity and adventure management for your guests with easy scheduling, dynamic pricing, real-time updates, and a mobile access solution.",
                //     },
                // },

                {
                    name: this.$t("product_menus.bi"),
                    link: "/business-intelligence",
                    image: require("@/assets/home/menu-icon/bi.svg"),
                    overview: {
                        name: this.$t("product_menus.bi"),
                        link: "/business-intelligence",
                        image: require("@/assets/home/menu-icon/bi.svg"),
                        description: this.$t("product_menus.bi_sub_text"),
                    },
                    subProducts: [{
                            name: "Portfolio Insights",
                            link: "/portfolio-insights",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Analyze the key revenue and operational metrics of the portfolio in real-time.",
                        },
                        {
                            name: "Property Insights",
                            link: "/property-insights",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Real-time insights for your revenue and operations on your finger-tips.",
                        },
                        {
                            name: "Dynamic Report",
                            link: "/dynamic-report",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Analyze the key revenue and operational metrics of the portfolio in real-time.",
                        },
                    ],
                },
                {
                    name: "HotelKey Rate Management System",
                    link: "/rate-management-system", // Add route link here
                    image: require("@/assets/home/menu-icon/rate_management.svg"),
                    overview: {
                        name: this.$t("menubar.solutions.hk_rms"),
                        link: "/rate-management-system",
                        image: require("@/assets/home/menu-icon/rate_management.svg"),
                        description: this.$t("product_menus.rms_sub_text"),
                    },
                    subProducts: [{
                            name: "Dynamic BAR",
                            link: "/dynamicbar",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Dynamic BAR",
                        },
                        {
                            name: "Seasons",
                            link: "/seasons",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Seasons",
                        },
                        {
                            name: "Special Events",
                            link: "/special-events",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Special Events",
                        },
                        {
                            name: "Notifications & Rules",
                            link: "/notifications-rules",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Notifications & Rules",
                        },
                        {
                            name: "Comp Shop Data",
                            link: "/comp-shop-data",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Comp Shop Data",
                        },
                        {
                            name: "Automated STR Integration",
                            link: "/automated-str-integration",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Automated STR Integration",
                        },
                        {
                            name: "Advanced Restriction Controls",
                            link: "/advanced-restriction-controls",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Advanced Restriction Controls",
                        },
                        {
                            name: "Policy Management",
                            link: "/policy-management",
                            image: require("@/assets/home/menu-icon/rate_management.svg"),
                            description: "Description for Policy Management",
                        },
                    ],
                },

                {
                    name: this.$t("product_menus.integrations"),
                    link: "/integrations",
                    image: require("@/assets/home/menu-icon/integrations.svg"),
                    overview: {
                        name: this.$t("product_menus.integrations"),
                        link: "/integrations",
                        image: require("@/assets/home/menu-icon/integrations.svg"),
                        description: this.$t("product_menus.integrations_sub_text"),
                    },
                },
                {
                    name: this.$t("product_menus.iot_key"),
                    link: "/ioTkey",
                    image: require("@/assets/home/menu-icon/iotkey.svg"),
                    overview: {
                        name: this.$t("product_menus.iot_key"),
                        link: "/ioTkey",
                        image: require("@/assets/home/menu-icon/iotkey.svg"),
                        description: this.$t("product_menus.iot_key_sub_text"),
                    },
                },

                // {
                //     name: "GuestKey",
                //     link: "/guest-key",
                //     image: require("@/assets/home/menu-icon/integrations.svg"),
                //     overview: {
                //         name: "GuestKey",
                //         link: "/guest-key",
                //         image: require("@/assets/home/menu-icon/integrations.svg"),
                //         description: "Streamline guest communication with customizable templates, real-time feedback, & automated responses for enhanced satisfaction & brand consistency.",
                //     },
                // },

                {
                    name: this.$t("menubar.solutions.hk_trainkey"),
                    link: "/train-key",
                    image: require("@/assets/home/menu-icon/integrations.svg"),
                    overview: {
                        name: this.$t("menubar.solutions.hk_trainkey"),
                        link: "/train-key",
                        image: require("@/assets/home/menu-icon/integrations.svg"),
                        description: "Reduce staff training hours with an efficient management tool that offers on-demand, interactive learning for your hotel staffs",
                    },
                },
                // Add main-products
            ],
        };
    },

     computed: {
        currentRouteName() {
            this.OnClickClose();
            return this.$route.name;
        },
        IsDarkMode() {
            return this.$route.meta.darkMode;
        },
        MobileView() {
            return this.$route.meta.mobileMode;
        },
        IsAfrica() {
            return this.$route.meta.mobileMode;
        },
        getLogo() {
            const logos = {
                "HK-Black": require("@/assets/logo/hk-logo-black.svg"),
                "HK-Retail": require("@/assets/logo/retailkey_logo.svg"),
                "HK-Paymentkey": require("@/assets/logo/paymentkey_logo.svg"),
                "hk-iotkey": require("@/assets/logo/iotkeylogo_h.svg"),
                "hk-activitykey": require("@/assets/logo/activitykey.svg"),
                "hk-eventkey": require("@/assets/logo/eventkey.svg"),
                "hk-tenantKey": require("@/assets/logo/tenantkey_logo.svg"),
            };
            return logos[this.IsDarkMode] || require("@/assets/logo/hk-logo-black.svg");
        },
        getMobileLogo() {
            return this.getLogo;
        },
    },
    methods: {
        toggleMobileMenu() {
            this.MobileMenu = !this.MobileMenu;
        },
        showSubProducts(index) {
            this.activeMainProductIndex = index;
            this.activeSubProduct = null;
        },
        isActive(link) {
            return this.$route.path === link;
        },
        toggleMenu(section) {
            this.showProducts = section === "products" ? !this.showProducts : false;
            this.showAboutus = section === "aboutus" ? !this.showAboutus : false;
            this.showIndustries = section === "industries" ? !this.showIndustries : false;
            this.showRegions = section === "regions" ? !this.showRegions : false;
        },
        openLink(link) {
            window.open(link, "_blank");
        },
        handleMouseLeave(section) {
            if (section === "products") this.showProducts = false;
            if (section === "aboutus") this.showAboutus = false;
            if (section === "regions") this.showRegions = false;
            if (section === "industries") this.showIndustries = false;
        },
      
        OnClickClose() {
            this.show = false;
        },
    },
    mounted() {
        window.addEventListener("scroll", () => {
            if (window.innerWidth <= 768) return;
            document.querySelector("nav").classList.toggle("scrolled", window.scrollY > 50);
        });
        this.showSubProducts(0);
    },
    watch: {
        $route() {
            this.showProducts = false;
            this.showAboutus = false;
            this.showIndustries = false;
            this.SideMenuBar = false;
            this.MobileMenu = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/config/variables.scss";
@import "@/assets/sass/main.scss";

.nav-links{
    color: #000 !important;
}

.mega-right .nav-link:hover {

    h3,
    p {
        color: $hk-blue;
    }
}

.mega-right .a-active.a-exact-active.nav-link {

    h3,
    p {
        color: $hk-blue;
    }
}
.nav-link:focus,
.nav-link:hover {
    color: #000;
}



@media (max-width: 768px) {
    .navbar-toggler{
        display: flex !important;
    }
    
}


#dropdownMenuLink::after {
    display: none !important;
}
.sec-hr {
    width: 80%;
}

.active {
    font-weight: bold;
    color: #007bff;
    /* Adjust to your desired active color */
}

.nav-bar-align {
    flex-direction: row;
    align-items: center;
}

.hover-text {
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
}

/* Horizontal scrollbar */
::-webkit-scrollbar {
    width: 4px;
    /* Reduced height for horizontal scrollbar */
}

/* Track */
::-webkit-scrollbar-track {
    background: white;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: rgb(109, 109, 109);
}



// .HK-Black .mega-right .a-active.a-exact-active.nav-link {
//   color: $hk-blue;
// }
// .HK-Retailkey .mega-right .a-active.a-exact-active.nav-link {
//   color: $hk-blue;
// }



.mega-product-heading {
    h2 {
        font-size: 14px;
        line-height: 35px;
        font-weight: 400;
        letter-spacing: 2px;
    }
}

.hk-row-menus {
    display: flex;

    img {
        width: 30px;
        margin-right: 15px;
    }

    h3 {
        font-size: 16px;
        font-weight: 400;
        line-height: 38px;
        margin-bottom: 0px;
    }

    p {
        color: $main-headings;
        font-size: 14px;
    }
}



.navbar-nav.hk-desktop-menu {
    align-items: center;
}

.navbar-nav.hk-mobile-menu {
    align-items: left;

    .dropdown-toggle {
        color: $main-headings;
    }

    .show>.nav-link {
        color: $main-headings !important;
    }
}

.bar_menu-icon {
    box-shadow: 0px 20px 40px rgb(0 0 0 / 11%);
}

.hk-navbar .navbar-nav .nav-item {
    padding: 0px 0px 0px 10px;

}

.hk-navbar {
    position: fixed;
    top: 0;
    width: 100%;
    background: #ffffff;
    padding: 0.9rem 0;
    transition: transform 1s ease;
    z-index: 1000;
}

.btn-request-demo {
    padding: 10px 14px;
    color: #fff;
    background: #1b95cd;
    font-weight: 500;

    border-radius: 8px;
    gap: 6px;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.btn-request-demo:hover {
    padding: 10px 14px;
    color: #fff;
    background: #1576a3;
    font-weight: 500;

    border-radius: 8px;
    gap: 6px;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    align-items: center;
}

.bg-megamenu {
    background: $white;
    box-shadow: 0px 20px 50px #00000012;

    // padding: 0.75rem;
    border-radius: 15px;

    .col-megamenu {
        // padding: 1.2rem;

        .nav.nav-tabs {
            float: left;
            display: block;
            margin-right: 20px;
            border-bottom: 0;
            border-right: 1px solid #ddd;
            padding-right: 15px;
        }

        .nav-tabs .nav-link {
            border: 1px solid transparent;
            border-top-left-radius: 0.25rem;
            border-top-right-radius: 0.25rem;
            background: #ccc;
        }

        .nav-tabs .nav-link.active {
            color: #495057;
            background-color: #007bff !important;
            border-color: transparent !important;
        }

        .nav-tabs .nav-link {
            border: 1px solid transparent;
            border-top-left-radius: 0rem !important;
            border-top-right-radius: 0rem !important;
        }

        .tab-content>.active {
            display: block;
            background: $bg-secondary;
            min-height: 165px;
        }

        .nav.nav-tabs {
            float: left;
            display: block;
            margin-right: 20px;
            border-bottom: 0;
            border-right: 1px solid transparent;
            padding-right: 15px;
        }
    }
}

.navbar .has-megamenu {
    position: static !important;
}

.navbar .megamenu {
    left: 5rem;
    width: 1440px;
    margin-top: 2.75rem;
    position: absolute;
    z-index: 111;
    right: 5rem;
}

.navbar .megamenu-aboutus {
    left: 50rem;
    right: 0;
    width: 12%;
    margin-top: 1.75rem;
    position: absolute;
    z-index: 111;
}

.navbar .megamenu-regions {
    left: 0rem;
    right: 20rem;
    width: 15%;
    margin-top: 2.75rem;
    position: absolute;
    padding: 1rem;
    z-index: 111;
}

.navbar .megamenu-industries {
    left: 10rem;
    right: 0rem;
    width: 30%;
    margin-top: 2.75rem;
    position: absolute;
    padding: 1rem;
    z-index: 111;
}

.navbar-nav .dropdown-menu {
    margin: auto;
}

// .navbar.fixed-top .navbar-collapse, .navbar.sticky-top .navbar-collapse{
//  overflow-y: auto;
//     max-height: 90vh;
//     margin-top:10px;
// }
.nav-item {
    cursor: pointer;
}

.mega-left {
    img {
        border-radius: 20px;
    }
}

.mega-right {
    .nav-pills .nav-link {
        text-align: left;
        padding: 1rem 0.5rem 1rem 0.5rem;
    }
}

.product-main-menu {
    padding-top: 1rem;
    background: $white;
}

.product-main-submenu {
    background: $bg-secondary;
    padding-top: 1rem;
    flex: 2;
    min-height: 550px;

    .nav-pills .nav-link.active,
    .nav-pills .show>.nav-link {
        background: $bg-secondary;
        color: $main-headings;
    }

    .nav-link {
        padding: 1rem 0.5rem 1rem 0.5rem;
    }
}

.hk-nav {
    position: relative;
    z-index: 1111;
}

.side-menu-grid {
    position: absolute;
    top: 0rem;
    transition: all 0.5s ease;
    z-index: 11;

    .hk-menus {
        position: fixed;
        width: 400px;
        height: 100vh;
        right: 0;
        top: 0rem;
        z-index: 1000;
        background: $white;

        .nav-link {
            font-size: 2rem;
            font-weight: 500;
            padding-bottom: 3rem;
        }

        .header-close-button {
            padding: 1.32rem 1rem 3rem 0px;
            display: flex;
            justify-content: flex-end;

            button {
                background: $main-headings;
                color: $white;
                font-size: 1.5rem;
                border-radius: unset;
                width: 50px;
                height: 50px;
                visibility: hidden;
            }
        }
    }

    .list-grou {
        --bs-list-group-bg: #ff090900;
    }
}

.sidenavopen {
    -webkit-transition: all 0.5s ease;
    transition: all 0.5s ease;
}

.HK-Retail .nav-link {
    color: $main-headings !important;
}

.sidemenu-height {
    height: 100vh;
    overflow-y: auto;
    padding-bottom: 10rem;
}

// HOVER EFFECT FOR PRODUCT AND SUB PRODUCT
// .nav-link.hk-row-menus:hover {
//     // background-color: #dfdfdf;
//     /* Change to the shade of blue you prefer */
// }

.hk-row-menus:hover h3 {
    color: #1c95cd;
}

.nav-link.hk-row-menus {
    transition: background-color 0.3s ease;
    border-radius: 10px;
    padding: 0px;
    padding-left: 0px;
}

// OVERVIEW SECTION HOVER EFFECT
.overview:hover {

 
    h6,
    p {
        color: #1c95cd;
    }
}

.overview {
    transition: all 0.3s ease;
}

@media (max-width: 768px) {
    .mob-product-name {
        font-size: 0.9rem;
    }

    .hk-navbar {
        padding: 10px 5px;
        position: fixed !important;
        top: 0px;
        width: 100%;
        background: #fff;

        .scrolled {
            background: #fff;
        }
    }

    .hk-nav .navbar-toggler {
        background-color: transparent;
        padding: 0;
    }

    .HK-White .nav-link {
        color: $main-headings !important;
    }

    .HK-Black .nav-link {
        color: $main-headings !important;
    }

    .IT.HomePage .HK-Black .nav-link {
        color: $main-headings !important;
    }

    .TH.HomePage .HK-Black .nav-link {
        color: $main-headings !important;
    }

    .hk-navbar .navbar-nav .nav-item {
        padding: 0px 0px !important;
    }

    .mob-nav-overflow {
        overflow-y: auto;
        height: 100vh;
        padding-bottom: 18rem;
        flex: 1;

        .nav-link {
            padding-bottom: 1rem;
            padding-top: 1rem;
            font-weight: 600;
            cursor: pointer;
        }

        .dropdown {
            padding-bottom: 1rem;
            padding-top: 1rem;
            font-weight: 600;
        }
    }

    .nav-africa-bg {
        background: transparent !important;
    }

    .africa {
        background: transparent;

        .navbar-toggler {
            border: var(--bs-border-width) solid rgb(255 255 255 / 0%) !important;
        }

        .scrolled {
            background: #fff;
        }
    }

    .product-container {
        margin-bottom: 20px;
    }

    .product-link {
        text-decoration: none;
        color: inherit;
    }

    .product-info {
        display: flex;
        align-items: center;
    }

    .product-img {
        width: 30px;
        /* Adjust width as needed */
        height: 30px;
        /* Adjust height as needed */
        margin-right: 10px;
        /* Space between image and text */
    }

    .product-name {
        margin: 0;
    }
}
</style>
